import createIcon from '../../createIcon';

/**
 * @component @name InsertInvitation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTNIMTJWMThIMTdWMTNaTTE2IDJWNEg4VjJINlY0SDVDMy44OSA0IDMuMDEgNC45IDMuMDEgNkwzIDIwQzMgMjEuMSAzLjg5IDIyIDUgMjJIMTlDMjAuMSAyMiAyMSAyMS4xIDIxIDIwVjZDMjEgNC45IDIwLjEgNCAxOSA0SDE4VjJIMTZaTTE5IDIwSDVWOUgxOVYyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const InsertInvitation = createIcon('InsertInvitation', [
  [
    'path',
    {
      d: 'M17 13H12V18H17V13ZM16 2V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4H18V2H16ZM19 20H5V9H19V20Z',
      key: '14gccj',
    },
  ],
]);

export default InsertInvitation;
